'use strict';

import { submitForm } from "../../commons/commonForms";
import { fromForms } from "../formsEnum";


const startFooterScript = () => {

  const headerElement = document.querySelector('header');
  const formSubscribe = document.getElementById('form-subscribe');
  const footerShowFormButtons = document.querySelectorAll('.show-form-subscribe');
  const footerHideFormButtons = document.querySelectorAll('.hide-form-subscribe');
  const formMessage = document.querySelector('.form--message');
  const alertContainer = formMessage.querySelector('.form--message--container__alert');
  const formMessagesContainer = formMessage.querySelector('.form--message--container');

  footerShowFormButtons.forEach(footerShowFormButton => {
    footerShowFormButton.addEventListener('click', (e) => {
      e.preventDefault();
      headerElement.classList.remove('open');
      formSubscribe.style.display = 'flex';
      formSubscribe.querySelector('input[name=name]').focus();
      const formOffsetTop = formSubscribe.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: formOffsetTop,
        behavior: 'smooth'
      });
    });
  });
  footerHideFormButtons.forEach(footerHideFormButton => {
    footerHideFormButton.addEventListener('click', (e) => {
      e.preventDefault();
      footerHideFormButton.parentElement.style.display = 'none';
      alertContainer.style.display = 'none';
      formMessagesContainer.style.display = 'flex';
    });
  });

  const isUserRegisterInDopplerTable = async () => {
    const newFormObj = new FormData(formSubscribe);
    const userEmail = newFormObj.get('email-input').trim();
    try {
      const url = document.getElementById('url_home').value + '/wp-admin/admin-ajax.php';
      const formData = new FormData();
      formData.append('action', 'is_user_register_in_doppler');
      formData.append('email', userEmail);

      const response = await fetch(url, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const responseData = await response.text();
      return parseInt(responseData) !== 0;
    } catch (error) {
      console.error('Error:', error);
    }
  };

  formSubscribe.querySelector('.submitButton').addEventListener('click', handleSubmit);

  async function handleSubmit(e) {
    e.preventDefault();
    formSubscribe.style.display = 'none';
    formMessage.style.display = 'flex';

    const isUserRegister = await isUserRegisterInDopplerTable();

    if (isUserRegister) {
      handleUserIsRegistered();
    } else {
      submitForm(e, formSubscribe, fromForms.footer).then(() => {
        handleFormSubmissionSuccess();
      });
    }
  }

  function handleUserIsRegistered() {
    alertContainer.style.display = 'flex';
    formMessagesContainer.style.display = 'none';
    formMessage.scrollIntoView({ behavior: 'smooth' });
  }

  function handleFormSubmissionSuccess() {
    if (window.captadorLoadConfig) {
      window.captadorLoadConfig();
    }
    formSubscribe.reset();
    formSubscribe.style.display = 'none';
    formMessage.style.display = 'flex';
    formMessage.scrollIntoView({ behavior: 'smooth' });
  }
}
export { startFooterScript }
